import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { HttpClient } from '@angular/common/http';
import { UtilsService } from '@services/utils.service';
import { CrudService } from '@services/crud.service';
import { VehicleTypes } from '@hardware/interfaces/vehicle-types.interface';

@Injectable({
  providedIn: 'root'
})
export class VehicleTypesService extends CrudService<VehicleTypes, number>{

  protected static BASE_API: string = `${environment.api.url}${environment.api.prefix}/vehicletype/v1`;

  constructor(
    protected _http: HttpClient,
    protected utilsService: UtilsService) {
    super(_http, VehicleTypesService.BASE_API, utilsService);
  }
}
